import React, { Component } from 'react';

import { Dialog } from '../../base/dialog';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';

/**
 * Dialog to ask the user whether they want to share their zoomed view/track with all participants.
 */
class ZoomShareDialog extends Component {
    /**
     * Initializes a new {@code ZoomShareDialog} instance.
     *
     * @param {Object} props - The component props.
     */
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
        this._onCancel = this._onCancel.bind(this);
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { isModeratorPinnedRemote, isVideoTypeScreenshare, t } = this.props;

        let content = t('dialog.zoomShareLocalTrackPrompt', 'Do you want your zoomed track to be visible to all participants?');

        if (isModeratorPinnedRemote) {
            content = t('dialog.zoomShareModeratorPrompt', 'Do you want this zoomed view to be visible to all participants?');
        } else if (isVideoTypeScreenshare) {
            content = t('dialog.zoomShareScreensharePrompt', 'Do you want your zoomed screen to be visible to all participants?');
        }

        const style = { fontSize: '14px',
            lineHeight: '22px',
            padding: '8px 0' };

        return (
            <Dialog
                cancelKey = 'dialog.zoomShareCancel'
                disableBlanketClickDismiss = { true }
                disableCloseIcon = { true }
                disableOverlay = { true }
                okKey = 'dialog.zoomShareConfirm'
                onCancel = { this._onCancel }
                onSubmit = { this._onSubmit }
                shouldCloseOnEscapePress = { false }
                titleKey = 'dialog.zoomShareTitle'
                width = 'small'>
                <div style = { style }>
                    { content }
                </div>
            </Dialog>
        );
    }

    /**
     * Callback invoked when the user confirms sharing zoom for everyone.
     *
     * @private
     * @returns {boolean}
     */
    _onSubmit() {
        this.props.onConfirm?.();

        return true;
    }

    /**
     * Callback invoked when the dialog is cancelled or rejected.
     *
     * @private
     * @returns {boolean}
     */
    _onCancel() {
        this.props.onCancel?.();

        return true;
    }
}

export default translate(connect()(ZoomShareDialog));
